/**
 * API访问授权接口
 * https://confluence.unipus.cn/pages/viewpage.action?pageId=26716835
 *
 * @format
 */
import axios from 'axios';

// sso 接口地址
const { REACT_APP_SSO_HOST } = process.env;

/**
 * 根据ST获取用户登录Token信息
 * @param params { service: string; ticket: string }
 * service就是登录时候传给sso的service 进行url encoding,必须和登录完全一样，否则或返回无效
 * @returns
 */
export const getToken = (params) => {
  const url = `${REACT_APP_SSO_HOST}/sso/serviceTicket/validate`;
  return axios.get(url, { params });
};

/**
 * Refresh Token
 * params: { rt: string }
 * @returns
 */
export const refreshToken = (params) => {
  const url = `${REACT_APP_SSO_HOST}/sso/4.0/sso/refresh_jwt`;
  return axios.post(url, params);
};

/**
 * 退出登录，跳转到sso页面
 */
export const logout = () => {
  const url = `${REACT_APP_SSO_HOST}/sso/logout`;
  const service = `${window.location.origin}`;
  window.location.assign(`${url}?service=${service}`);
};
